export var BestEnrollmentType;
(function (BestEnrollmentType) {
    BestEnrollmentType["Enrolled"] = "Active";
    BestEnrollmentType["Queued"] = "Pending";
    BestEnrollmentType["Rejected"] = "Rejected";
})(BestEnrollmentType || (BestEnrollmentType = {}));
BestEnrollmentType['Enrolled'] = 'Active';
BestEnrollmentType['Queued'] = 'Pending';
BestEnrollmentType['Rejected'] = 'Rejected';
//# sourceMappingURL=BestEnrollmentType.js.map